<template>
  <div class="flex items-center">
    {{ Elevation }} <span class="text-xs">m</span>
    <span class="i group ml-2">
      i
      <span class="absolute top-[-30px] left-[5px] w-max bg-g3 px-2 py-[1px] hidden group-hover:flex items-center">
        <span class="text-sm">{{ Height }}</span> <span class="text-xs">m</span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    Height() {
      return this.config?.drone?.status?.height != null
        ? parseFloat(this.config.drone?.status.height).toFixed(2)
        : ENV.NO_DATA;
    },

    Elevation() {
      return this.config?.drone?.status?.elevation != null
        ? parseFloat(this.config.drone?.status.elevation).toFixed(2)
        : ENV.NO_DATA;
    },
  },
};
</script>
